export * from './money.js';
export * from './tax.js';
export * from './currency.js';
export * from './barcode.js';
export * from './sale.js';
export * from './promotions.js';
export * from './receipt.js';
export * from './exchange.js';
export * from './permissions.js';
export * from './features.js';
export * from './sizes.js';
export * from './theme.js';
export * from './types.js';

/** A device-generated id. Uploads can be retried forever and never duplicate. */
export function newId(): string {
  const g = globalThis as { crypto?: { randomUUID?: () => string } };
  if (g.crypto?.randomUUID) return g.crypto.randomUUID();
  // Fallback for very old browsers; still collision-safe enough for one shop.
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function nowIso(): string {
  return new Date().toISOString();
}

/** Local calendar day as YYYY-MM-DD — reports are read in shop time, not UTC. */
export function dayKey(d: Date | string): string {
  const date = typeof d === 'string' ? new Date(d) : d;
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}
